export default __webpack_public_path__ + "static/media/bookIcon.040d9741.svg";